// Shared content + asset references for MapCast marketing site

export const ASSETS = {
  icon: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mapcast-web/artifacts/zfwpxiiy_WhatsApp%20Image%202026-07-19%20at%2005.56.15.jpeg",
  discover: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mapcast-web/artifacts/2u63ug43_WhatsApp%20Image%202026-08-01%20at%2012.07.12.jpeg",
  heroPhone: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mapcast-web/artifacts/bfdvv3kp_hero%20main%20p1.jpeg",
  watchLive: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mapcast-web/artifacts/dibmggr2_watch%20live%20p2.jpeg",
  dropBounty: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mapcast-web/artifacts/c0v97y47_drop%20a%20bounty%20p7.jpeg",
  mapcaster: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mapcast-web/artifacts/4u8z7upi_mapcaster%20p8.webp",
  goLive: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mapcast-web/artifacts/29uyd56g_go%20live%20p3.jpeg",
  inboxTablet: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mapcast-web/artifacts/tcbmwkrd_inbox%20p9.webp",
  inboxPhone: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mapcast-web/artifacts/xt4xpll9_inbox%20p9.jpeg",
  mapTablet: "https://customer-assets-lxgj4vgw.emergentagent.net/job_mapcast-web/artifacts/f9ie35sx_main%20hero%20p1.jpeg",
};

export const SUPPORT_EMAIL = "support@mapcast.cc";
export const COMPANY_NAME = "MapCast BV";
export const COMPANY_ADDRESS = "Herengracht 320, 1016 CE Amsterdam";
export const DOMAIN = "Mapcast.cc";

export const CHAPTERS = [
  {
    num: "01",
    title: "The map is the app",
    tag: "DISCOVER",
    body: "Open MapCast to a dark, neon map centered on you. Purple-glowing pins mark every MapCaster nearby. Tap one, peek their rate and viewer count, and drop straight into their live stream. No timeline. No algorithm. Just wherever something is happening, right now.",
  },
  {
    num: "02",
    title: "Go live from real places",
    tag: "BROADCAST",
    body: "Tap the camera and you're on air via a real-time video pipeline. Set a title, choose who watches, pick your castcoin-per-minute rate, and broadcast the world exactly as it unfolds around you — a concert, a street, a sunrise.",
  },
  {
    num: "03",
    title: "Ask the world for a live",
    tag: "BOUNTIES",
    body: "Want to see a place right now? Drop a bounty: pin the spot, write your request, set a reward, and your castcoins go into escrow. Whoever delivers the live earns the pot. It turns the whole planet into an on-demand broadcast grid.",
  },
  {
    num: "04",
    title: "Earn every minute",
    tag: "MONETIZE",
    body: "Viewers pay per minute, tip instantly, and fund bounties. castcoins move wallet-to-wallet in a single atomic transaction. MapCasters cash out via Stripe — the world becomes a place you can broadcast from and get paid for.",
  },
];

export const STEPS = [
  { n: "1", title: "Open the map", body: "See every live MapCaster around you as a glowing pin — no follows required." },
  { n: "2", title: "Tap in or go live", body: "Watch a stream pay-per-minute, or hit the camera and broadcast your moment." },
  { n: "3", title: "Earn & request", body: "Get tipped, cash out, or drop a bounty asking the world for a view." },
];

export const FAQS = [
  { q: "What is MapCast?", a: "MapCast is a live-video social platform anchored to the world map. Instead of a feed or timeline, everything happens on a map: broadcasters (MapCasters) go live from real places, and viewers discover them by where they are — not who they follow." },
  { q: "How do MapCasters earn money?", a: "Through pay-per-minute viewing, instant castcoin tips, and bounties — paid requests to broadcast from a specific location. castcoins are bought via in-app purchase and MapCasters can cash out via Stripe once eligible." },
  { q: "What is a bounty?", a: "A bounty is a paid request for a live stream from a specific place. You pin a location, write what you want to see, set a reward, and your castcoins go into escrow until a MapCaster delivers the live." },
  { q: "Is my exact location shared?", a: "No. Locations shown on the map are coarsened to roughly 1 km buckets for anyone who isn't the broadcaster. You choose what you show and when you go live." },
  { q: "Can I watch without an account?", a: "Yes — guests can watch. Tipping, bounties, and going live require signing in with Google or Apple so wallets and payouts stay secure." },
  { q: "Is MapCast available now?", a: "Yes — MapCast is live on the App Store and Google Play. Download it for iOS or Android from the links on this page, or scan the QR codes with your phone." },
];


export const PRESS = {
  boilerplateShort:
    "MapCast is the world's AI-powered, real-time location video platform. Broadcasters — MapCasters — go live from real places on a neon world map, and viewers discover them by where they are, not who they follow. Watch pay-per-minute, tip creators, or drop a bounty to request a live from anywhere.",
  boilerplateLong:
    "MapCast reimagines live video as something spontaneous and location-aware. Instead of a chronological feed or an algorithmic timeline, everything happens on a map: purple-glowing pins mark every MapCaster nearby, and a tap drops you straight into their stream. Viewers pay per minute, tip instantly, and can post bounties — paid requests for a live from a specific spot, held in escrow until delivered. Built safety-first with location coarsening, atomic wallets, and moderation, MapCast is on a path to become the world's first AI-responsible live broadcasting platform, with face-blur, privacy zones, content safety and verified MapCasters on the roadmap.",
  facts: [
    { k: "Category", v: "Live video · Social · Maps" },
    { k: "Platforms", v: "iOS & Android" },
    { k: "Status", v: "Live on the App Store & Google Play" },
    { k: "Website", v: "Mapcast.cc" },
  ],
  colors: [
    { name: "Obsidian", hex: "#08090F" },
    { name: "Violet", hex: "#7C3AED" },
    { name: "Purple", hex: "#A855F7" },
    { name: "Pink", hex: "#FF3D8B" },
    { name: "Live Red", hex: "#FF2D55" },
    { name: "castcoin Gold", hex: "#F5C542" },
  ],
};
